// client/src/components/admin/project/ProjectCompletionSummary.js
import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL;

export default function ProjectCompletionSummary({ interactive = false }) {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);

  // 완료 처리 대상 프로젝트 목록 조회 (최대 5개)
  const fetchCompletionProjects = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/projects/completion-list`, {
        credentials: 'include'
      });
      const data = await res.json();
      
      if (data.ok) {
        const list = data.projects || [];
        setCount(list.length);
        setProjects(list.slice(0, 5)); // 최대 5개만
      }
    } catch (error) {
      console.error('완료 처리 대상 목록 조회 오류:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompletionProjects();
  }, []);

  // 날짜 포맷팅
  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}`;
  };

  return (
    <div className="project-completion-summary">
      {/* 헤더 */}
      <div className="project-completion-summary__header">
        <h3 className="project-completion-summary__title">
          프로젝트 완료 처리
        </h3>
        {count > 0 && (
          <span className="project-completion-summary__badge">
            {count}
          </span>
        )}
      </div>

      {/* 로딩 */}
      {loading && (
        <div className="project-completion-summary__loading">
          로딩 중...
        </div>
      )}

      {/* 목록 */}
      {!loading && projects.length === 0 && (
        <div className="project-completion-summary__empty">
          완료 처리할 프로젝트가 없습니다.
        </div>
      )}

      {!loading && projects.length > 0 && (
        <div className="project-completion-summary__list">
          {projects.map((project) => (
            <div
              key={project.id}
              className="project-completion-summary__item"
            >
              <div className="project-completion-summary__item-content">
                <div className="project-completion-summary__item-left">
                  <div className="project-completion-summary__item-number">
                    {project.projectNumber}
                  </div>
                  <div className="project-completion-summary__item-marketer">
                    광고주: {project.marketerName}
                  </div>
                </div>
                <div className="project-completion-summary__item-right">
                  <div className="project-completion-summary__item-date-label">
                    정산일
                  </div>
                  <div className="project-completion-summary__item-date-value">
                    {formatDate(project.completionAvailableDate)}
                  </div>
                </div>
              </div>
            </div>
          ))}
          
          {count > 5 && (
            <div className="project-completion-summary__more">
              외 {count - 5}건 더 있습니다
            </div>
          )}
        </div>
      )}
    </div>
  );
}

